import React, {useEffect, useContext, useRef, useState} from "react";
import {ApolloMessage} from "../../../atom/Apollo_Mesasge";
import CampaignFormZeus from "./CampaignFormZeus";
import {ApolloRightDrawerContext} from "../../../molecule/Apollo_RightDrawer";
import {ApolloContext} from "../../../atom/Apollo_Context";
import {AdCampaignUpdate, CampaignZeus, LogRecord} from "./CampaignModelZeus";
import {
  getDefaultSchedule,
  scheduleArrayToString,
  scheduleStringToArray
} from "../../../atom/CAMPAIGN/Apollo_Schedule";
import moment from "moment";
import {ApolloAxios, getResultType} from "../../../atom/Apollo_ApiRequest3";
import {get_zeus_campaign_path, patch_zeus_campaign_path} from "../../../atom/Apollo_links";
import {formatLogFromSchedule} from "../../../common/PLATFORM/zeus/FunctionZeus";
import {
  Option, options_bidding,
  options_state_edit,
  options_target, options_zeus_budget_allocation, options_zeus_fq_class, options_zeus_fq_term, options_zeus_fq_type,
  valueToOption,
  valueToOptionNull, ZEUS_DELIVERY_TYPE,
  ZEUS_FQ_CLASS,
  ZEUS_FQ_TERM,
  ZEUS_DOMAIN_SETTING
} from "../../../atom/Apollo_styles";
import {BLANK} from "../ms/common/CommonConst";
import {
  ApolloEventRecord,
  createLogDate,
  createUserLogItemListByOption, createUserLogItemListByOptionBool,
  createUserLogItemListFromArrayAddSB,
  createUserLogItemListFromArrayAddSB2, createUserLogItemListFromCheck2, createUserLogItemListFromDomainSetting,
  createUserLogItemListFromNumber, createUserLogItemListFromNumberWitZeroToBlank,
  createUserLogItemListFromString,
  ItemList,
  LogData
} from "../../../atom/Apollo_EventRecord";
import {
  getAccountDeletedSetPoints,
  getAccountsDeletedAudience,
  getTrackerAudience,
  getTrackerSetPoint,
} from "../../../common/Apollo_CommonUtil";
import {ApolloDialog} from "../../../atom/Apollo_Dialog";
import {ApolloConfirmNotActiveDialog} from "../../../organism/HERA/ConfirmNotActiveDialog";

type CampaignData = {
  platformAccountId: number,
  campaignId: number,
  listReloadFunc? : any;
}

// 画面名：キャンペーン作成（Zeus）
const CampaignEditZeus = ({platformAccountId, campaignId, listReloadFunc}: CampaignData) => {
  const {state} = useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
  const today = moment().hour(0).minutes(0).seconds(0);
  const [schedule, setSchedule] = useState<boolean[][]>(getDefaultSchedule());
  const campaignData = useRef<CampaignZeus | null>(null);
  const beforeEditRecord = useRef<LogRecord | null>(null);
  const optionAudiences2 = useRef<Option[]>([]);
  const optionSetPoints2 = useRef<Option[]>([]);
  const isExistsNotActiveAudience = useRef<boolean>(false);
  const isExistsNotActiveSetPoint = useRef<boolean>(false);
  const isExistsDeletedAudience = useRef<boolean>(false);
  const isExistsDeletedSetPoint = useRef<boolean>(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false)

  const [showExtAdCampaignBudgetProportion, setShowExtAdCampaignBudgetProportion] = useState<boolean>(false);
  const [campaign, setCampaign] = useState<CampaignZeus>({
    id: 0,
    createdAt: "",
    updatedAt: "",
    lastUpdateUserId: 0,
    adAccountId: platformAccountId,
    name: "",
    status: 2,
    budgetLimitDaily: 100,
    schedule: scheduleArrayToString(getDefaultSchedule()),
    startDate: today.add(1, "days").format("YYYY-MM-DDTHH:mm"),
    endDate: today.endOf('month').format("YYYY-MM-DDTHH:mm"),
    campaignGoal: -1,
    cpa: 1,
    autoBidding: false,
    extAdCampaignBudgetProportion: 0,
    excludingAudiences: [],
    trackingPoints: [],
    deliveryType: 0,
    billingType: 0,
    pmpType: null,
    fqExist: false,
    fqClass: 1,
    fqTerm: 1,
    fqCount: 1,
    fqType: 1,
    budgetAllocation: 1,
    domainSetting: 0,
    adCampaignExcludingDomains: [],
    adCampaignTargetDomains: [],
  });
  const [endDate, setEndDate] = useState(campaign.endDate);
  const [endDateInputType, setEndDateInputType] = useState(1);
  const [beforeStartDate, setBeforeStartDate] = useState("");

  useEffect(() => {

    // キャンペーン情報取得
    ApolloAxios.get(`${get_zeus_campaign_path}/${campaignId}`).then(response => {
      if (response.status !== 200) {
        return Promise.reject({
          open: true,
          type: "error",
          errmsg: "キャンペーン情報を取得できませんでした",
        });
      }

      const resultData: CampaignZeus = response.data;
      const tmpStartDate = resultData.startDate ? moment(resultData.startDate).format("YYYY-MM-DDTHH:mm") : ""
      let tmpEndDateInputType = 1;
      let tmpEndDate = today.endOf('month').format("YYYY-MM-DDTHH:mm");
      let endDate = resultData.endDate;
      if (endDate) {
        tmpEndDateInputType = 2;
        setEndDateInputType(2);
        tmpEndDate = moment(endDate).format("YYYY-MM-DDTHH:mm");
        setEndDate(tmpEndDate);
      }
      setBeforeStartDate(tmpStartDate)

      setSchedule(scheduleStringToArray(resultData.schedule))
      const newCampaign: CampaignZeus = {
        id: resultData.id,
        createdAt: resultData.createdAt,
        updatedAt: resultData.updatedAt,
        lastUpdateUserId: Number(resultData.lastUpdateUserId),
        adAccountId: resultData.adAccountId,
        name: resultData.name,
        status: resultData.status,
        budgetLimitDaily: resultData.budgetLimitDaily,
        schedule: resultData.schedule,
        startDate: tmpStartDate,
        endDate: tmpEndDate,
        campaignGoal: resultData.campaignGoal,
        cpa: resultData.cpa,
        autoBidding: resultData.autoBidding,
        extAdCampaignBudgetProportion:  resultData.extAdCampaignBudgetProportion,
        excludingAudiences: resultData.excludingAudiences? resultData.excludingAudiences: [],
        trackingPoints: resultData.trackingPoints? resultData.trackingPoints: [],
        deliveryType: resultData.deliveryType,
        billingType: resultData.billingType,
        pmpType: resultData.pmpType ?? null,

        fqExist: resultData.fqClass != null && resultData.fqTerm != null && resultData.fqCount != null && resultData.fqType != null,

        // フリークエンシーに関する項目がNULLの場合は初期値を入れておく
        fqClass: resultData.fqClass == null ? ZEUS_FQ_CLASS.CAMPAIGN : resultData.fqClass,
        fqTerm: resultData.fqTerm == null ? ZEUS_FQ_TERM.DAYLY : resultData.fqTerm,
        fqCount: resultData.fqCount == null ? 1 : resultData.fqCount,
        fqType: resultData.fqType == null ? 1 : resultData.fqType,

        budgetAllocation: resultData.budgetAllocation,
        domainSetting: resultData.domainSetting,
        adCampaignTargetDomains: resultData.adCampaignTargetDomains,
        adCampaignExcludingDomains: resultData.adCampaignExcludingDomains,
      }
      setCampaign(newCampaign);

      if (newCampaign.extAdCampaignBudgetProportion === 0) {
        setShowExtAdCampaignBudgetProportion(false);
      } else {
        setShowExtAdCampaignBudgetProportion(true);
      }

      beforeEditRecord.current = {
        adAccountId: newCampaign.adAccountId,
        name: newCampaign.name,
        status: newCampaign.status,
        budgetLimitDaily: newCampaign.budgetLimitDaily,
        schedule: formatLogFromSchedule(newCampaign.schedule),
        startDate: newCampaign.startDate.replace("T", " "),
        endDate: (tmpEndDateInputType === 2 && newCampaign.endDate)? newCampaign.endDate.replace("T", " "): "継続的配信",
        campaignGoal: newCampaign.campaignGoal,
        cpa: newCampaign.cpa,
        autoBidding: newCampaign.autoBidding,       
        extAdCampaignBudgetProportion:  newCampaign.extAdCampaignBudgetProportion,
        excludingAudiences: newCampaign.excludingAudiences,
        excludingAudienceNames: [],
        trackingPoints: newCampaign.trackingPoints,
        trackingPointNames: [],
        deliveryType: newCampaign.deliveryType,
        billingType: newCampaign.billingType,
        adCampaignExcludingDomains: newCampaign.adCampaignExcludingDomains ?? null,
        pmpType: newCampaign.pmpType,
        fqExist: newCampaign.fqExist,
        fqClass: newCampaign.fqExist ? newCampaign.fqClass : 0,
        fqTerm: newCampaign.fqExist ? newCampaign.fqTerm : 0,
        fqType: newCampaign.fqExist ? newCampaign.fqType : 0,
        fqCount: newCampaign.fqExist ? newCampaign.fqCount : 0,
        budgetAllocation: newCampaign.budgetAllocation,
        domainSetting: newCampaign.deliveryType == ZEUS_DELIVERY_TYPE.DSP ? newCampaign.domainSetting : -1,
        adCampaignTargetDomains: newCampaign.adCampaignTargetDomains ?? null,
      }

    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    });
  }, []);

  const handleOpenConfirm = () => {
    if (!openConfirmDialog) setOpenConfirmDialog(true)
  }

  const handleCloseConfirm = () => {
    if (openConfirmDialog) setOpenConfirmDialog(false)
  }

  const handleSubmit = async (
    optionAudiences: Option[],
    optionSetPoints: Option[],
  ) => {
    isExistsNotActiveAudience.current = false;
    isExistsNotActiveSetPoint.current = false;
    isExistsDeletedAudience.current = false;
    isExistsDeletedSetPoint.current = false;

    optionAudiences2.current = optionAudiences
    optionSetPoints2.current = optionSetPoints

    if (state.current.trackerId) {
      const localValAudience = await getTrackerAudience(state.current.trackerId);
      if (localValAudience.message !== "") {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: localValAudience.message
          }
        });
        return
      }
      if (localValAudience.result) {
        for (const id of campaign.excludingAudiences) {
          const val = localValAudience?.result?.find(v => v.ID === id)
          if (val?.isActive === false) {
            isExistsNotActiveAudience.current = true;
            break;
          }
        }
      }

      const localValSetPoint = await getTrackerSetPoint(state.current.trackerId);
      if (localValSetPoint.message !== "") {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: localValSetPoint.message
          }
        });
        return
      }
      if (localValSetPoint.result) {
        for (const id of campaign.trackingPoints) {
          const val = localValSetPoint?.result?.find(v => v.ID === id)
          if (val?.isActive === false) {
            isExistsNotActiveSetPoint.current = true;
            break;
          }
        }
      }
    }

    const localValDeletedAudience = await getAccountsDeletedAudience(state.current.accountId);
    if (localValDeletedAudience.message !== "") {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: localValDeletedAudience.message
        }
      });
      return
    }
    if (localValDeletedAudience.result) {
      for (const id of campaign.excludingAudiences) {
        const val = localValDeletedAudience?.result?.find(v => v.ID === id)
        if (val) {
          isExistsDeletedAudience.current = true;
          break;
        }
      }
    }

    const localValDeletedSetPoint = await getAccountDeletedSetPoints(state.current.accountId);
    if (localValDeletedSetPoint.message !== "") {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: localValDeletedSetPoint.message
        }
      });
      return
    }
    if (localValDeletedSetPoint.result) {
      for (const id of campaign.trackingPoints) {
        const val = localValDeletedSetPoint?.result?.find(v => v.ID === id)
        if (val) {
          isExistsDeletedSetPoint.current = true;
          break;
        }
      }
    }

    if (
      isExistsNotActiveAudience.current
      || isExistsNotActiveSetPoint.current
      || isExistsDeletedAudience.current
      || isExistsDeletedSetPoint.current
    ) {
      handleOpenConfirm();
      return;
    }

    await handleSubmitExecute();
  };

  const handleSubmitExecute = async() => {
    // 更新API実行・操作履歴ログ格納
    let isSuccess = false;
    const newStartDate = moment(campaign.startDate);
    const newEndDate = endDateInputType === 1 ? null : moment(endDate);
    const beforeExcludingAudienceNames: string[] = [];
    const beforeTrackingPointNames: string[] = [];
    const afterExcludingAudienceNames: string[] = [];
    const afterTrackingPointNames: string[] = [];

    // 変更前
    if (beforeEditRecord.current) {
      beforeEditRecord.current?.excludingAudiences.map((id: number) => {
        if (valueToOptionNull(id, optionAudiences2.current)) {
          beforeExcludingAudienceNames.push(valueToOption(id, optionAudiences2.current).label);
        }
      });

      beforeEditRecord.current?.trackingPoints.map((id: number) => {
        if (valueToOptionNull(id, optionSetPoints2.current)) {
          beforeTrackingPointNames.push(valueToOption(id, optionSetPoints2.current).label);
        }
      });

      beforeEditRecord.current = {
        ...beforeEditRecord.current,
        excludingAudienceNames: beforeExcludingAudienceNames,
        trackingPointNames: beforeTrackingPointNames,
      };
    }

    // 変更後
    campaign.excludingAudiences.map((id: number) => {
      if(valueToOptionNull(id, optionAudiences2.current)) {
        afterExcludingAudienceNames.push(valueToOption(id, optionAudiences2.current).label);
      }
    });

    campaign.trackingPoints.map((id: number) => {
      if(valueToOptionNull(id, optionSetPoints2.current)) {
        afterTrackingPointNames.push(valueToOption(id, optionSetPoints2.current).label);
      }
    });

    const body: AdCampaignUpdate = {
      adAccountId: campaign.adAccountId,
      name: campaign.name,
      status: campaign.status,
      budgetLimitDaily: campaign.budgetLimitDaily,
      schedule: scheduleArrayToString(schedule),
      startDate: moment(beforeStartDate).isBefore(moment().add(1, 'day').startOf('day'))? null: newStartDate.format(),
      endDate: newEndDate ? newEndDate.format(): newEndDate,
      campaignGoal: campaign.campaignGoal,
      cpa: campaign.cpa ?? 0,
      autoBidding: campaign.autoBidding,
      extAdCampaignBudgetProportion:  campaign.extAdCampaignBudgetProportion ?? 0,
      excludingAudiences: campaign.excludingAudiences,
      trackingPoints: campaign.trackingPoints,
      pmpType: campaign.pmpType,
      fqClass: campaign.fqExist? campaign.fqClass : null,
      fqTerm: campaign.fqExist? campaign.fqTerm : null,
      fqCount: campaign.fqExist? campaign.fqCount : null,

      // フリークエンシーキャップ項目は「1：vimp固定」で送信
      fqType: campaign.fqExist? 1 : null,

      budgetAllocation: campaign.deliveryType == ZEUS_DELIVERY_TYPE.DSP ? campaign.budgetAllocation : null,
      domainSetting: campaign.domainSetting,
      adCampaignExcludingDomains: campaign.domainSetting === ZEUS_DOMAIN_SETTING.DOMAIN_EXCLUSION ? campaign.adCampaignExcludingDomains?.filter(x => x !== "") ?? [] : [],
      adCampaignTargetDomains: campaign.domainSetting === ZEUS_DOMAIN_SETTING.DOMAIN_SPECIFICATION ? campaign.adCampaignTargetDomains?.filter(x => x !== "") ?? [] : [],
    }

    const executeLog = createUserLog(
      state,
      "パフォーマンス広告",
      "キャンペーン",
      "更新",
      "キャンペーン（パフォーマンス広告）更新",
      beforeEditRecord.current,
      {
        adAccountId: campaign.adAccountId,
        name: campaign.name,
        status: campaign.status,
        budgetLimitDaily: campaign.budgetLimitDaily,
        schedule: formatLogFromSchedule(body.schedule ?? ""),
        startDate: `${newStartDate.format("YYYY-MM-DD HH:mm")}`,
        endDate: newEndDate ? `${newEndDate.format("YYYY-MM-DD HH:mm")}` : "継続的配信",
        campaignGoal: campaign.campaignGoal,
        cpa: campaign.cpa ?? 0,
        autoBidding: campaign.autoBidding,
        extAdCampaignBudgetProportion:  campaign.extAdCampaignBudgetProportion ?? 0,
        excludingAudiences: campaign.excludingAudiences,
        excludingAudienceNames: afterExcludingAudienceNames,
        trackingPoints: campaign.trackingPoints,
        trackingPointNames: afterTrackingPointNames,
        deliveryType: campaign.deliveryType,
        billingType: campaign.billingType,
        adCampaignExcludingDomains:  campaign.domainSetting == 1 ? campaign.adCampaignExcludingDomains : [],
        pmpType: campaign.pmpType,
        fqExist: campaign.fqExist,
        fqClass: campaign.fqExist ? campaign.fqClass : 0,
        fqTerm: campaign.fqExist ? campaign.fqTerm : 0,
        fqType: campaign.fqExist ? campaign.fqType : 0,
        fqCount: campaign.fqExist ? campaign.fqCount : 0,
        budgetAllocation:  campaign.deliveryType == ZEUS_DELIVERY_TYPE.DSP ? campaign.budgetAllocation : null,
        domainSetting: campaign.deliveryType == ZEUS_DELIVERY_TYPE.DSP ? campaign.domainSetting : 0,
        adCampaignTargetDomains:  campaign.domainSetting == 2 ? campaign.adCampaignTargetDomains : [],
      },
      String(campaignId), // キャンペーンID
      beforeEditRecord.current?.name? beforeEditRecord.current.name: "", // キャンペーン名
      BLANK, // 広告グループID
      BLANK, // 広告グループ名
    );
    executeLog.targetID = String(campaignId);
    executeLog.targetName = beforeEditRecord.current?.name? beforeEditRecord.current.name: "";
    ApolloEventRecord({...executeLog, logType: "execute"});


    ApolloAxios.patch(`${patch_zeus_campaign_path}/${campaignId}`, body).then(response => {
      if (response.status !== 200) {
        return Promise.reject({
          open: true,
          type: "error",
          errmsg: "キャンペーンの更新に失敗しました。",
        });
      }

      isSuccess = true;
      campaignData.current = response.data;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "success",
          message: "キャンペーンを更新しました",
        }
      });
    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    }).finally(() => {
      const resultLog: LogData = {
        ...executeLog,
        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        targetName: campaignData.current? campaignData.current?.name: "",
        result: isSuccess ? "成功" : "失敗",
        campaignName: campaignData.current? campaignData.current?.name: executeLog.campaignName,
      };
      ApolloEventRecord({...resultLog, logType: "result"});
      if(isSuccess) listReloadFunc && listReloadFunc();
    });
  };

  const handleGoBack = () => {
    // キャンセルボタンクリック時のアクション
    setDrawerState({
      type: 'close',
      payload: {
        ...drawerState,
        open: false,
      }
    });
  }

  return (
    <React.Fragment>
      <CampaignFormZeus
        campaignId={campaignId}
        campaignState={{
          campaign: campaign,
          setCampaign: setCampaign,
        }}
        scheduleState={{
          schedule: schedule,
          setSchedule: setSchedule,
        }}
        endDateState={{
          endDate: endDate,
          setEndDate: setEndDate,
          endDateInputType: endDateInputType,
          setEndDateInputType: setEndDateInputType,
        }}
        submitAction={handleSubmit}
        goBackAction={handleGoBack}
        showExtAdCampaignBudgetProportion={showExtAdCampaignBudgetProportion}
        setShowExtAdCampaignBudgetProportion={setShowExtAdCampaignBudgetProportion}
        beforeStartDate={beforeStartDate}
      />
      <ApolloDialog open={openConfirmDialog} setOpen={setOpenConfirmDialog}>
        <ApolloConfirmNotActiveDialog
          isExistsNotActiveAudience={isExistsNotActiveAudience.current}
          isExistsNotActiveSetPoint={isExistsNotActiveSetPoint.current}
          isExistsDeletedAudience={isExistsDeletedAudience.current}
          isExistsDeletedSetPoint={isExistsDeletedSetPoint.current}
          handleSave={handleSubmitExecute}
          handleClose={handleCloseConfirm}
        />
      </ApolloDialog>
    </React.Fragment>
  );
}

const createUserLog = (
  apolloContex: any,
  menu: string,
  category: string,
  actionType: string,
  displayName: string,
  beforeInfo: LogRecord | null,
  afterInfo: LogRecord,
  campaignId?: string,
  campaignName?: string,
  adGroupId?: string,
  adGroupName?: string,
) => {
  const items: ItemList[] = [
    createUserLogItemListFromNumber("プラットフォームアカウントID", "adAccountId", beforeInfo, afterInfo),
    createUserLogItemListFromString("キャンペーン名", "name", beforeInfo, afterInfo),
    createUserLogItemListByOption("ステータス", "status", beforeInfo, afterInfo, options_state_edit),
    createUserLogItemListFromNumber(  "日予算額", "budgetLimitDaily", beforeInfo, afterInfo),
    createUserLogItemListFromArrayAddSB("掲載スケジュール", "schedule", beforeInfo, afterInfo),
    createUserLogItemListFromString("掲載期間_開始", "startDate", beforeInfo, afterInfo),
    createUserLogItemListFromString("掲載期間_終了", "endDate", beforeInfo, afterInfo),
    createUserLogItemListByOption("キャンペーンの目的", "campaignGoal", beforeInfo, afterInfo, options_target),
    createUserLogItemListFromNumber(  "目標獲得単価", "cpa", beforeInfo, afterInfo),
    createUserLogItemListByOptionBool("入札戦略", "autoBidding", beforeInfo, afterInfo, options_bidding),
    createUserLogItemListByOption("フリークエンシーキャップ階層", "fqClass", beforeInfo, afterInfo, options_zeus_fq_class),
    createUserLogItemListByOption("フリークエンシーキャップ期間", "fqTerm", beforeInfo, afterInfo, options_zeus_fq_term),
    createUserLogItemListByOption("フリークエンシーキャップ項目", "fqType", beforeInfo, afterInfo, options_zeus_fq_type),
    createUserLogItemListFromNumberWitZeroToBlank("フリークエンシーキャップ回数", "fqCount", beforeInfo, afterInfo),
    createUserLogItemListByOption("予算配分", "budgetAllocation", beforeInfo, afterInfo, options_zeus_budget_allocation),
    createUserLogItemListFromNumber("外部配信予算割合", "extAdCampaignBudgetProportion", beforeInfo, afterInfo),
    createUserLogItemListFromArrayAddSB("オーディエンス除外設定", "excludingAudienceNames", beforeInfo, afterInfo),
    createUserLogItemListFromDomainSetting("配信先ドメイン除外/指定選択", "domainSetting", beforeInfo, afterInfo ),
    createUserLogItemListFromArrayAddSB2("配信先ドメイン除外設定", "adCampaignExcludingDomains", beforeInfo, afterInfo),
    createUserLogItemListFromArrayAddSB2("配信先ドメイン指定設定", "adCampaignTargetDomains", beforeInfo, afterInfo),
    createUserLogItemListFromArrayAddSB("測定ポイント設定", "trackingPointNames", beforeInfo, afterInfo),
  ];

  const retObj = createLogDate(
    apolloContex,
    menu,
    category,
    actionType,
    displayName,
    items,
    campaignId,
    campaignName,
    adGroupId,
    adGroupName,
  );

  return retObj
}

export default CampaignEditZeus;
